import { useState } from "react";
import { dialCodeOptions } from "@/utils/countryCodes";

export function useDialCode(defaultCode = "+91") {
  const [dialCode, setDialCode] = useState(defaultCode);
  const selected =
    dialCodeOptions.find((opt) => opt.value === dialCode) || dialCodeOptions[0];
  return { dialCode, setDialCode, selected };
}
